import { Component, Input, OnInit,ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { VisaExtendedState } from '../../utility/interfaces/visa-extended-state';
import { getSubTaskDetails, getStepStatusUpdate, loadSubTaskDetails, updateStepStatus } from 'visa-store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { TaskStep, SubTaskDetails, PrimaryData, I140FileUploadConfiguration } from 'app-models';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { I140FileUploadService } from '../../../../services/i140-file-upload.service';
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { ReferenceLibrary } from '../../../../data/models/referenceLibrary.model';
import { DatePipe } from '@angular/common';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import * as moment from 'moment';
import { OutsideImagilityService } from './outside-imagility.service';
import { take } from 'rxjs/operators';
import * as errorUtils from "src/app/modules/utility/global-utils";
//import { I140FileUploadConfiguration } from 'app-models';

@Component({
  selector: 'app-outside-imagility',
  templateUrl: './outside-imagility.component.html',
  styleUrls: ['./outside-imagility.component.scss']
})
export class OutsideImagilityComponent implements OnInit {

  observableSubscription$ = new Subject();
  // stepDetails: TaskStep;
  disabledControls: boolean;
  otherDocumentsFileUploadConfigurations: I140FileUploadConfiguration;
  subTask: SubTaskDetails;
  fileTypeOption = [];
  selectedFileType = [];
  disableFields = false;
  uploadedFile: any;
  envPath;
  uploadedReceiptsList: any[] = [];
  refData = ['RECPET'];
  // uploadedFileList: any[];
  receiptCategoryList: ReferenceLibrary[] = [];
  selectedReceiptCategory = [];
  receiptNumber;
  filingDate;
  receiptDate;
  currentStatus = 'Filed';
  userType;
  stepUploadPetitionDocs: TaskStep;
  stepUploadRcpts: TaskStep;
  @Input() primaryData: PrimaryData;
  secondStepUpdateStatusCalled = false;
  receiptVisaType: string = "";
  receiptNumberRegexp = new RegExp('^[A-Za-z]{3}.[0-9]{9}$');
  @ViewChild('getReceiptsForm', { static: true }) getReceiptsForm: NgForm;

  constructor(private store: Store<VisaExtendedState>,
    private toastrService: ToastrService,
    private uploadService: I140FileUploadService,
    public datepipe: DatePipe,
    public stepStatusUpdatePayloadCostruction: StepStatusUpdatePayloadService,
    private confirmationService: ConfirmationService,
    private outsideImagilityService: OutsideImagilityService) {
  }

  ngOnInit() {

    this.userType = sessionStorage.getItem('userTypeRole');
    this.store.pipe(select(getStepStatusUpdate))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: ImagilityBaseResponse) => {
        if (response && response.status === 200) {
          //this.toastrService.success(response.message);
        }
      });

    this.setFileUploadConfigurations();
    this.getReceiptInfo();
    this.store.pipe(select(getSubTaskDetails))
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: SubTaskDetails) => {
        if (response.id) {
          this.subTask = response;
          this.stepUploadPetitionDocs = this.subTask['taskStepDetails'].find(x => x['stepActionList'][0].layoutCode === "UPLOAD_PETION_DOCS");
          this.stepUploadRcpts = this.subTask['taskStepDetails'].find(x => x['stepActionList'][0].layoutCode === "UPLOAD_RCPTS");
          this.receiptVisaType = this.subTask.taskTypeDetails.visaType ? this.subTask.taskTypeDetails.visaType : this.subTask.taskTypeDetails.immCategoryCode;
          if (this.stepUploadPetitionDocs.stepStatusDetails.stepStatusCode === this.stepUploadRcpts.stepStatusDetails.stepStatusCode) {
            this.secondStepUpdateStatusCalled = false;
            if (this.stepUploadPetitionDocs.stepStatusDetails.stepStatusCode === "COMPLETE" && this.userType != 'Beneficiary') {
              this.currentStatus = "COMPLETE";
              this.disableFields = true;
            } else if (this.userType === 'Beneficiary' && (this.stepUploadPetitionDocs.stepStatusDetails.stepStatusCode === "SUBMIT" || this.stepUploadPetitionDocs.stepStatusDetails.stepStatusCode === "COMPLETE")) {
              this.currentStatus = this.stepUploadPetitionDocs.stepStatusDetails.stepStatusCode;
              this.disableFields = true;
            }
            else {
              this.currentStatus = "Filed";
              this.disableFields = false;
            }
          } else {
            if (!this.secondStepUpdateStatusCalled) {
              this.secondStepUpdateStatusCalled = true;
              const payload = {
                endDate: moment.utc().format('YYYY-MM-DD hh:mm:ss'),//moment(new Date(), "YYYY-mm-dd hh:mm:ss",true),
                responseCode: null,
                responseNote: '',
                startDate: moment.utc().format('YYYY-MM-DD hh:mm:ss'),
                statusCode: this.stepUploadPetitionDocs.stepStatusDetails.stepStatusCode,
                stepNote: '',
                reviewCode: '',
                reviewNote: '',
                isAttorneyNotify: 0,
                isBeneficiaryNotify: 0,
                isPetitionerNotify: 0
              };
              this.updateStepStatusStep(payload, this.stepUploadRcpts.id);
            }
          }
          this.setFileUploadConfigurations();
        }
      });

    let element: any = {
      code: "RECNOTC",
      createdBy: 1,
      description: "Receipt Notice",
      group: "RECPET",
      id: 219,
      modifiedBy: null,
      name: "Receipt Notice",
      refGroupdesc: "Receipt Type Petition"
    }
    this.receiptCategoryList.push(element);
    this.selectedReceiptCategory = element;
    this.getDocuments();

    this.envPath = environment.docs;
    

  }

  getReceiptInfo() {
    const petitionId = this.primaryData.caseType === 'I140' ? this.primaryData.caseId :this.primaryData.petitionId;
    this.outsideImagilityService.getReceiptInfo(this.primaryData.visatype,
      this.primaryData.caseType,petitionId ).subscribe((data) => {
        if (data != null) {
          //   this.receiptDate = data['receiptDate'] ? new Date(data['receiptDate']): null;
          //  this.filingDate = data['filingDate'] ? new Date(data['filingDate']): null;
          this.receiptNumber = data['receiptNumber'];

        }
      });
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  setFileUploadConfigurations() {
    const caseId = this.primaryData.petitionId || this.primaryData?.caseId;
    this.otherDocumentsFileUploadConfigurations = Object.assign({}, {
      disableControls: this.disableFields,
      isDocumentTypeRequired: true,
      isDocumentUploadRequired: true,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      isOutside: 1,
      getDocTypeApiUrl: `/${this.primaryData.visatype}/task/${this.primaryData.subTaskId}/documentTypes`,
      // getDocTypeApiUrl: `/${this.subTask.taskTypeDetails.visaType}/petitionType/${this.subTask.taskTypeDetails.petitionType}/group/BENLICDOC/documentTypes`,
      getApiUrl: `/${this.primaryData.visatype}/${this.primaryData.caseType}/${caseId}/documents`,
      postApiUrl: `/${this.primaryData.visatype}/${this.primaryData.caseType}/${caseId}/document/category`,
      deleteApiUrl: `/${this.primaryData.visatype}/${this.primaryData.caseType}/${caseId}/document/`,
      documentTypeDropdownCode: 'BENLICDOC'
    });


    //const temp = [];
    // this.outsideImagilityService
    //   .getDocumentTypeList(this.subTask.taskTypeDetails.visaType, this.subTask.id)
    //   .subscribe((data) => {
    //     if (data != null) {
    //       data.forEach(element => {
    //         if (element.entityType != null && !temp.some(e => e.entityType.code === element.entityType.code)) {
    //           temp.push(element);
    //         }
    //       });
    //       this.fileTypeOption = temp;
    //     }
    //   });

  }


  getDocuments() {
    // this.uploadedFileList = [];
    // this.outsideImagilityService.getUploadedDocuments(this.primaryData.caseType,
    //   this.subTask.taskTypeDetails.visaType, this.subTask.petitionId).subscribe((data) => {
    //     this.uploadedFileList = data;
    //   });
    const caseId = this.subTask.petitionId || this.primaryData?.caseId;
    this.outsideImagilityService.getUploadedReceiptList(
        this.receiptVisaType, this.primaryData.caseType, caseId, this.stepUploadRcpts ? this.stepUploadRcpts.id : this.primaryData.superTaskId, this.selectedReceiptCategory['group']).subscribe((data: ReferenceLibrary[]) => {
        if (data != null && data.length > 0) {
          this.uploadedReceiptsList = [];
          this.receiptDate = data[0]['receiptDate'] ? new Date(data[0]['receiptDate']) : null;
          this.filingDate = data[0]['filingDate'] ? new Date(data[0]['filingDate']) : null;
          data.forEach(element => {
            this.uploadedReceiptsList.push(element);
          });
        } else {
          this.uploadedReceiptsList = [];
          this.receiptDate = null;
          this.filingDate = null;
        }
      });
  }

  onUpload(event, fileUpload) {
    const file: any = event.files[0];
    file.fileName = event.files[0].name;
    const payload = new FormData();
    payload.append('file', file, file.name);
    const caseId = this.subTask.petitionId || this.primaryData?.caseId;
    let postApiUrl = `/${this.subTask.taskTypeDetails.visaType}/${this.primaryData.caseType}/${caseId}/document/category/${this.selectedFileType['entityType']['group']}/fileCategory/${this.selectedFileType['entityType']['code']}`;
    this.uploadService.uploadDocument(postApiUrl, payload).subscribe((response: ImagilityBaseResponse) => {
      this.toastrService.success(response.message, 'Success');
      this.getDocuments();
      fileUpload.clear();
    });
  }

  onReceiptUpload(event, fileUpload) {
    for (const file of event.files) {
      this.uploadedFile = file;
      this.uploadedFile['fileName'] = file.name;
    }
    fileUpload.clear();
    let payload = new FormData();
    payload.append("file", this.uploadedFile, this.uploadedFile.name);
    let fDate;
    if (this.filingDate)
      fDate = this.datepipe.transform(this.filingDate, 'yyyy-MM-dd');
    const caseId = this.subTask.petitionId || this.primaryData?.caseId;
    this.outsideImagilityService.postReceipt(this.receiptVisaType, this.primaryData.caseType, caseId,
      this.stepUploadRcpts ? this.stepUploadRcpts.id : this.primaryData.superTaskId, this.selectedReceiptCategory['group'], this.receiptNumber, this.selectedReceiptCategory['code'],
      this.datepipe.transform(this.receiptDate, 'yyyy-MM-dd'), fDate, payload).subscribe((response: any) => {
        if (response.status == 200) {
          this.saveCaseStatus();
          this.toastrService.success(response.message, 'Success');
          this.getDocuments();
        }
      });
  }

  download(file) {
    this.uploadService.downloadDocuments(environment.docs + file.fileLocation.substring(23), file.fileLocation.substring(23));
  }

  viewDocument(item) {
    const docPath = item.substring(23);
    window.open(`${environment.docs}${docPath}`, '_blank');
  }

  confirmDelete(uploadedFile, type) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      accept: () => {
        if (type == 'file')
          this.deleteFiles(uploadedFile);
        else
          this.deleteReceipt(uploadedFile);
      },
      reject: () => {
      }
    });
  }

  deleteFiles(uploadedFile) {
    if (uploadedFile['id'] != null) {
      let deleteApiUrl = `/${this.subTask.taskTypeDetails.visaType}/${this.primaryData.caseType}/${this.subTask.petitionId}/document/${uploadedFile.id}`;

      this.uploadService.deleteUploadDocument(deleteApiUrl).subscribe((response: any) => {
        if (response) {
          this.toastrService.success(response.message, 'Success');
          this.getDocuments();
          this.uploadedFile = '';
        }
        else {
          this.uploadedFile = '';
        }
      });
    }
  }

  deleteReceipt(uploadedFile) {
    if (uploadedFile['id'] != null) {
      this.outsideImagilityService.deleteReceipt(this.subTask.taskTypeDetails.visaType, this.primaryData.caseType, this.subTask.petitionId, uploadedFile.id).subscribe((response: any) => {
        if (response) {
          this.toastrService.success(response.message, 'Success');
          this.getDocuments();
          this.uploadedFile = '';
        }
      });
    }
    else {
      this.uploadedFile = '';
    }
  }


  changeStatus(status) {
    const payload = {
      endDate: moment.utc().format('YYYY-MM-DD hh:mm:ss'),//moment(new Date(), "YYYY-mm-dd hh:mm:ss",true),
      responseCode: null,
      responseNote: '',
      startDate: moment.utc().format('YYYY-MM-DD hh:mm:ss'),
      statusCode: status,
      stepNote: '',
      reviewCode: '',
      reviewNote: '',
      isAttorneyNotify: 0,
      isBeneficiaryNotify: 0,
      isPetitionerNotify: 0
    };

    // let id1, id2;
    // if (status == 'COMPLETE' || status == 'SUBMIT') {
    //   //  id1 = this.uploadTaskStatusId;
    //   // id2 = this.receiptTaskStatusId;
    //   id2 = this.uploadTaskStatusId;
    //   id1 = this.receiptTaskStatusId;
    // }
    // else {
    //   id2 = this.uploadTaskStatusId;
    //   id1 = this.receiptTaskStatusId;
    // }

    this.updateStepStatusStep(payload, this.stepUploadPetitionDocs.id);
  }

  saveCaseStatus(){
    this.outsideImagilityService.postCaseStatus(this.receiptNumber,this.primaryData.subTaskId)
    .pipe(takeUntil(this.observableSubscription$))
    .subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastrService.success(response.message, 'Success');
      }
    });
  }

  handleStatusEdit() {
    this.changeStatus('NEW');
  }

  updateStepStatusStep(payload1, id) {
    this.store.dispatch(
      updateStepStatus(
        {
          payload: payload1,
          subTaskId: this.subTask.id,
          stepId: id,
          visaType: this.subTask.taskTypeDetails.visaType
        }));
  }




}
